import { LayerType, PluginType, type IExportPlugin } from '@/version-types';
import vectorLayerBehavior from './behavior';
import { VectorLayer } from './domain';

export * from './plugins';
export { VectorLayer } from './domain';
export {
    applyVectorTextLayout,
    calculateRealDistance,
    calculateVirtualDistance,
    createDefaultReflection,
    createDefaultShadow,
    createEmptyVectorEditingSnapshot,
    createVectorTextEditingCandidate,
    getVectorLayerHost,
    normalizeVectorTextPadding,
    requestVectorSVGPreview,
    resolveVectorTextPaddingLimits,
    resolveVectorTextContentOffset,
    resolveVectorTextInlineSize,
} from './utils';
export type { IEdgelessVectorLayer, VectorSVGMaterial } from './types';

export { EdgelessVectorLayer } from './edgeless';

/**
 * 矢量图层插件
 */
export const vectorLayerPlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.LAYER,
    name: LayerType.VECTOR_LAYER,
    createInstance({ identity }) {
        return [{ key: 'VectorLayer', value: new VectorLayer(identity) }];
    },
    createBehavior() {
        return vectorLayerBehavior;
    },
};
